import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { init } from 'pp-react-l10n';
import { loadI18nMetadata } from "@paypalcorp/worldready";
import HomeMainComponent from './components/HomeMainComponent.js';
import CategoriesMainComponent from './components/CategoriesMainComponent.js';
import ArticleMainComponent from './components/ArticleMainComponent.js';
import ThankyouMainComponent from './components/ThankyouMainComponent';

init({
  content: {
    staticContent,
  },
});

function countryCode(country) {
  if (country === 'GB') {
    country = 'UK';
  }
  return country;
}

async function bootstrap() {
  const decodedTimezone = new DOMParser()
    .parseFromString(timezone || '', 'text/html').body.textContent;
  const country = countryCode(dataLayer.contentCountry);

  try {
    // Load worldready metadata for the current locale. eg: en-IN
    // https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data#client-side
    await loadI18nMetadata({ locale: `${language}-${country.toUpperCase()}` });
  } catch (error) {
    console.error('Error loading localization metadata: ', error);
  }

  if (pageName === 'home') {
    ReactDOM.hydrateRoot(
      document.querySelector('#homeMain-container'),
      <HomeMainComponent
        carouselInfo={carouselInfo}
        userAccountInfo={userAccountInfo}
        encryptedAccountNumber={encryptedAccountNumber}
        topicsInfo={topicsInfo}
        isPopArticleEnabled={isPopArticleEnabled}
        legalFooter={legalFooter}
        locale={locale}
        country={country}
        tilesInfo={tilesInfo}
        colors={colors}
        totalArticles={totalArticles}
        topicsHash={topicsHash}
        isNewMppEnabled={isNewMppEnabled}
        helpContainer={helpContainer}
        timezone={decodedTimezone}
        language={language}
      />,
    );
  }

  if (pageName === 'categories') {
    ReactDOM.hydrateRoot(
      document.querySelector('#categoriesmain-container'),
      <CategoriesMainComponent
        resultsInfo={resultsInfo}
        userAccountInfo={userAccountInfo}
        encryptedAccountNumber={encryptedAccountNumber}
        sections={leftnavData}
        popArticlesHomeInfo={popArticlesHomeInfo}
        legalFooter={legalFooter}
        isPopArticleEnabled={isPopArticleEnabled}
        locale={locale}
        country={country}
        totalResultsList={totalResultsList}
        topicsHash={topicsHash}
        topics={leftnavData}
        refID={refID}
        isHomeBtnEnabled={isHomeBtnEnabled}
        isNewMppEnabled={isNewMppEnabled}
        helpContainer={helpContainer}
        timezone={decodedTimezone}
        language={language}
      />,
    );
  }

  if (pageName === 'article') {
    ReactDOM.hydrateRoot(
      document.querySelector('#articleMainContainer'),
      <ArticleMainComponent
        name="Social"
        articleInfo={articleInfo}
        userAccountInfo={userAccountInfo}
        encryptedAccountNumber={encryptedAccountNumber}
        topicsHash={topicsHash}
        gatewayInfo={gatewayInfo}
        isPopArticleEnabled={isPopArticleEnabled}
        legalFooter={legalFooter}
        popArticlesHomeInfo={popArticlesHomeInfo}
        locale={locale}
        country={country}
        isRatingEnabled={isRatingEnabled}
        isHomeBreadcrumbEnabled={isHomeBreadcrumbEnabled}
        isNewMppEnabled={isNewMppEnabled}
        helpContainer={helpContainer}
        isECMLive={isECMLive}
        timezone={decodedTimezone}
        language={language}
      />,
    );
  }

  if (pageName === 'thankyou') {
    const containerElement = document.querySelector('#thankyouMainContainer');
    const root = createRoot(containerElement);

    root.render(
      <ThankyouMainComponent
        userAccountInfo={userAccountInfo}
        encryptedAccountNumber={encryptedAccountNumber}
        isPopArticleEnabled={isPopArticleEnabled}
        legalFooter={legalFooter}
        locale={locale}
        country={country}
        tilesInfo={tilesInfo}
        categorieValues={categorieValues}
        colors={colors}
        totalArticles={totalArticles}
        topicsHash={topicsHash}
        isNewMppEnabled={isNewMppEnabled}
        helpContainer={helpContainer}
        timezone={decodedTimezone}
        language={language}
      />,
    );
  }
}

bootstrap();
